'use client'

import AnimatedSection from '@/components/AnimatedSection'
import Main from './_blocks/Main'
import ApplicationOverview from './_blocks/ApplicationOverview'
import BusinessProblems from './_blocks/BusinessProblems'
import Directions from './_blocks/Directions'
import B2cSolution from './_blocks/B2cSolution'
import EasyOfUse from './_blocks/EasyOfUse'
import CtaBanner from './_blocks/CtaBanner'
import ReadySolution from './_blocks/ReadySolution'
import Tariff from './_blocks/Tariff'
import Clients from '@/app/services/_blocks/Clients'
import Portfolio from '@/app/portfolio/[portfolio]/_blocks/Portfolio'
import Contact from '@/app/_blocks/Main_redesign/Contact'
import styles from './styles.module.css'

const Page = () => {
	return (
		<article className={styles.content}>
			<Main />
			<div className={styles.whiteBlock}>
				<ApplicationOverview />
			</div>
			<BusinessProblems />
			<Directions />
			<div className={styles.whiteBlock}>
				<B2cSolution />
			</div>
			<EasyOfUse />
			<AnimatedSection animation='slideUp'>
				<div className={styles.ctaBannerBlock}>
					<CtaBanner />
				</div>
			</AnimatedSection>
			<ReadySolution />
			<Tariff />
			<AnimatedSection animation='slideUp'>
				<div className={styles.clientsBlock}>
					<Clients />
				</div>
			</AnimatedSection>
			<AnimatedSection animation='slideUp'>
				<div className={styles.portfolioBlock}>
					<Portfolio />
				</div>
			</AnimatedSection>
			<AnimatedSection animation='slideUp'>
				<div className={styles.contactBlock}>
					<Contact />
				</div>
			</AnimatedSection>
		</article>
	)
}

export default Page

/*
 * ============================================================================
 * СТАРАЯ ВЕРСИЯ СТРАНИЦЫ B2C (закомментирована, не удалять).
 * Использовала блоки из src/blocks_fintech_b2c/*.
 * Новая версия выше построена по образцу страницы competition-sheet-system.
 * ----------------------------------------------------------------------------
 *
 * import FAQ from '@/blocks_fintech_b2c/Faq/Faq'
 * import FeaturesIcons from '@/blocks_fintech_b2c/FeaturesIcons/FeaturesIcons'
 * import GradientForm from '@/blocks_fintech_b2c/GradientForm/GradientForm'
 * import HeroSection from '@/blocks_fintech_b2c/HeroSection/HeroSection'
 * import InterfaceSlider from '@/blocks_fintech_b2c/InterfaceSlider/InterfaceSlider'
 * import PricingTable from '@/blocks_fintech_b2c/PricingTable/PricingTable'
 * import ProductInfo from '@/blocks_fintech_b2c/ProductInfo/ProductInfo'
 * import SliderSteps from '@/blocks_fintech_b2c/SliderSteps/SliderSteps'
 * import VideoBlock from '@/blocks_fintech_b2c/VideoBlock/VideoBlock'
 * import AnimatedSection from '@/components/AnimatedSection'
 * import styles from './styles.module.css'
 *
 * const Page = () => {
 * 	return (
 * 		<article>
 * 			<section className={styles.content}>
 * 				<AnimatedSection animation="slideUp">
 * 					<HeroSection />
 * 				</AnimatedSection>
 * 				<AnimatedSection animation="slideUp">
 * 					<FeaturesIcons />
 * 				</AnimatedSection>
 * 				<AnimatedSection animation="slideUp">
 * 					<ProductInfo />
 * 				</AnimatedSection>
 * 				<AnimatedSection animation="slideUp">
 * 					<SliderSteps />
 * 				</AnimatedSection>
 * 				<AnimatedSection animation="slideUp">
 * 					<InterfaceSlider />
 * 				</AnimatedSection>
 * 				<AnimatedSection animation="slideUp">
 * 					<PricingTable />
 * 				</AnimatedSection>
 * 				<AnimatedSection animation="slideUp">
 * 					<VideoBlock />
 * 				</AnimatedSection>
 * 				<AnimatedSection animation="slideUp">
 * 					<GradientForm />
 * 				</AnimatedSection>
 * 				<AnimatedSection animation="slideUp">
 * 					<FAQ />
 * 				</AnimatedSection>
 * 			</section>
 * 		</article>
 * 	)
 * }
 *
 * export default Page
 * ============================================================================
 */
